import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import {
  GlobalInstruction,
  CreateGlobalInstructionDto,
  UpdateGlobalInstructionDto,
} from "./GlobalInstruction.model";

export function useGlobalInstructionApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      createGlobalInstruction: async (input: CreateGlobalInstructionDto) =>
        apiResolver<GlobalInstruction>(
          api.post("/platform/global-instructions", input)
        ),
      updateGlobalInstruction: async (
        globalInstructionId: string,
        input: UpdateGlobalInstructionDto
      ) =>
        apiResolver<GlobalInstruction>(
          api.put(`/platform/global-instructions/${globalInstructionId}`, input)
        ),
      deleteGlobalInstruction: async (globalInstructionId: string) =>
        apiResolver<{ success: boolean }>(
          api.delete(`/platform/global-instructions/${globalInstructionId}`)
        ),
      getGlobalInstruction: async (globalInstructionId: string) =>
        apiResolver<GlobalInstruction | null>(
          api.get(`/platform/global-instructions/${globalInstructionId}`)
        ),
      getGlobalInstructions: async (releaseId: number) =>
        apiResolver<GlobalInstruction[]>(
          api.get(`/platform/global-instructions?releaseId=${releaseId}`)
        ),
    }),
    [api]
  );
}

